export const autoFillForm = ({influencerState = {}, userState = {}}) => {
    const form = {
        channels: [],
        mainChannelPlatform: null,
        age18Acknowledgment: false,
        guardianAcknowledgment: false,
        guardianInfo: {
            firstName: '',
            lastName: '',
            relationship: ''
        },
        eulaAccepted: false,
        guardianAccepted: false,
        agreementAccepted: false,
        disclaimerAccepted: false,
        country: '',
        state: '',
        city: '',
        eulas: [],
        language: '',
        creatorCode: ''
    };

    const {accountInfo} = userState;

    if (accountInfo) {
        form.language = accountInfo.preferredLanguage || form.language;
        form.country = accountInfo.country || form.country || 'US';
    }

    const {affiliateAccount: aff} = influencerState;

    if (aff) {
        form.city = aff.city || form.city;
        form.state = aff.state || form.state;
        form.country = aff.country || form.country;
        form.age18Acknowledgment = aff.ageConfirmed || form.age18Acknowledgment;
        form.guardianInfo = aff.guardianInfo || form.guardianInfo;
        form.channels = (aff.socialChannels || []).map(ch => {
            if (ch.mainChannel) {
                form.mainChannelPlatform = ch.platform;
            }
            return ch;
        });
    }

    return form;
};
